import type { AjusteImagen, BrandPalette } from './types';
import { ICONOS } from './iconos';

export function aplicarEnDocumento(
  doc: Document,
  slots: Record<string, string>,
  palette: BrandPalette | null,
  ajustes: Record<string, AjusteImagen>,
  activo?: string | null
): void {
  if (palette) {
    const root = doc.documentElement;
    (Object.keys(palette) as (keyof BrandPalette)[]).forEach((key) => {
      root.style.setProperty(key, palette[key]);
    });
  }
  doc.querySelectorAll<HTMLElement>('[data-slot]').forEach((el) => {
    const name = el.getAttribute('data-slot');
    if (!name || !(name in slots)) return;
    el.classList.toggle('clientelo-slot-activo', name === activo);
    const value = slots[name] ?? '';
    if (el.hasAttribute('data-icon')) {
      if (!value) return;
      el.setAttribute('data-icon', value);
      const svg = ICONOS[value];
      if (svg) el.innerHTML = svg;
      return;
    }
    const img = el.tagName === 'IMG' ? (el as HTMLImageElement) : el.querySelector('img');
    if (img) {
      if (value && img.getAttribute('src') !== value) img.src = value;
      if (!value) img.removeAttribute('src');
      const ajuste = ajustes[name];
      if (ajuste) {
        img.style.objectPosition = `${ajuste.x}% ${ajuste.y}%`;
        img.style.transform = ajuste.zoom > 1 ? `scale(${ajuste.zoom})` : '';
        img.style.transformOrigin = `${ajuste.x}% ${ajuste.y}%`;
      }
      return;
    }
    el.textContent = value;
  });
}
